module.exports = __webpack_public_path__ + "static/media/Logo.1bbd0561.png";